// types
import { BiMenuItem } from '../types';

export const BI_MENU_SCHEMA: Array<BiMenuItem> = [
    {
        title: 'Savings',
        reports: [
            { section: 'Savings', claim: 'report.bi.admin.340bsavings', name: '340B Savings', rxmodels: [] },
            { section: 'Savings', claim: 'report.bi.ce.340bsavings', name: '340B Savings', rxmodels: [] },
            {
                section: 'Savings',
                claim: 'report.bi.admin.cpperformance',
                name: 'Contract Pharmacy',
                rxmodels: ['CP', 'CPTPA'],
            },
            {
                section: 'Savings',
                claim: 'report.bi.ce.cpperformance',
                name: 'Contract Pharmacy',
                rxmodels: ['CP', 'CPTPA'],
            },
        ],
    },
    {
        title: 'Spend',
        reports: [
            { section: 'Spend', claim: 'report.bi.admin.spend', name: 'Total Spend', rxmodels: [] },
            { section: 'Spend', claim: 'report.bi.ce.spend', name: 'Total Spend', rxmodels: [] },
            {
                section: 'Spend',
                claim: 'report.bi.ce.splitbillingspend',
                name: 'Split Billing',
                rxmodels: ['SPLIT', 'SPLITMATCH'],
            },
            {
                section: 'Spend',
                claim: 'report.bi.admin.splitbillingspend',
                name: 'Split Billing',
                rxmodels: ['SPLIT', 'SPLITMATCH'],
            },
        ],
    },
    {
        title: 'Matches',
        reports: [
            {
                section: 'Matches',
                claim: 'report.bi.admin.cematcheddispenses',
                name: 'View by Facility',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // verity
            {
                section: 'Matches',
                claim: 'report.bi.ce.cematcheddispenses',
                name: 'View by Facility',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // ce user
            {
                section: 'Matches',
                claim: 'report.bi.rx.matchesbyce',
                name: 'View by Facility',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // rx user
            {
                section: 'Matches',
                claim: 'report.bi.admin.rxmatcheddispenses',
                name: 'View by Pharmacy',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // verity
            {
                section: 'Matches',
                claim: 'report.bi.ce.cematcheddispensesbyrx',
                name: 'View by Pharmacy',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // ce user
            {
                section: 'Matches',
                claim: 'report.bi.rx.matchesbypharmacy',
                name: 'View by Pharmacy',
                rxmodels: ['CP', 'CPTPA', 'SPLITMATCH'],
            }, // rx user
        ],
    },
    {
        title: 'Purchase Optimization',
        reports: [
            {
                section: 'Purchase Optimization',
                claim: 'report.bi.admin.verisave',
                name: 'Verisave',
                rxmodels: [],
            },
            {
                section: 'Purchase Optimization',
                claim: 'report.bi.ce.verisave',
                name: 'Verisave',
                rxmodels: [],
            },
            {
                section: 'Purchase Optimization',
                claim: 'report.bi.admin.contractpricevalidation',
                name: 'Contract Price Validation',
                rxmodels: [],
            },
            {
                section: 'Purchase Optimization',
                claim: 'report.bi.ce.contractpricevalidation',
                name: 'Contract Price Validation',
                rxmodels: [],
            },
        ],
    },
    {
        title: 'Business Review',
        reports: [
            {
                section: 'Business Review',
                claim: 'report.bi.admin.businessreviewperiodic',
                name: 'Periodic',
                rxmodels: [],
            },
            {
                section: 'Business Review',
                claim: 'report.bi.ce.businessreviewperiodic',
                name: 'Periodic',
                rxmodels: [],
            },

            { section: 'Business Review', claim: 'report.bi.admin.businessreview', name: 'Annual', rxmodels: [] },
            {
                section: 'Business Review',
                claim: 'report.bi.admin.pharmacydispensefees',
                name: 'Pharmacy',
                rxmodels: ['CP', 'CPTPA'],
            },
            {
                section: 'Business Review',
                claim: 'report.bi.rx.pharmacydispensefees',
                name: 'Pharmacy',
                rxmodels: ['CP', 'CPTPA'],
            },
        ],
    },
    {
        title: 'Detailed Reports',
        reports: [
            {
                section: 'Detailed Reports',
                claim: 'report.bi.admin.matcheddispensesdetails',
                name: 'Matched Dispenses',
                rxmodels: ['CP', 'CPTPA'],
            },
            {
                section: 'Detailed Reports',
                claim: 'report.bi.ce.matcheddispensesdetails',
                name: 'Matched Dispenses',
                rxmodels: ['CP', 'CPTPA'],
            },

            {
                section: 'Detailed Reports',
                claim: 'report.bi.admin.contractpharmacyinvoices',
                name: 'CP Invoices',
                rxmodels: ['CP'],
            },
            {
                section: 'Detailed Reports',
                claim: 'report.bi.ce.contractpharmacyinvoices',
                name: 'CP Invoices',
                rxmodels: ['CP'],
            },

            {
                section: 'Detailed Reports',
                claim: 'report.bi.admin.cptpainvoices',
                name: 'CPTPA Invoices',
                rxmodels: ['CPTPA'],
            },
            {
                section: 'Detailed Reports',
                claim: 'report.bi.ce.cptpainvoices',
                name: 'CPTPA Invoices',
                rxmodels: ['CPTPA'],
            },

            {
                section: 'Detailed Reports',
                claim: 'report.bi.admin.splitbillinginvoicesdetail',
                name: 'Split Billing Invoices',
                rxmodels: ['SPLIT', 'SPLITMATCH'],
            },
            {
                section: 'Detailed Reports',
                claim: 'report.bi.ce.splitbillinginvoicesdetail',
                name: 'Split Billing Invoices',
                rxmodels: ['SPLIT', 'SPLITMATCH'],
            },
        ],
    },
];
